<template>
  <div class="promocodes-block">
    <div class="promocodes-field-wrap" v-show="userInfo.UserType === 1">
      <span class="promocodes-label nowrap"> {{ localizeList.selectDiscountType }} </span>
      <base-select :items="discountTypes"
                   :tooltip="true"
                   :max-height="250"
                   :positionRight="true"
                   v-model="discount.type"
                   class="promocodes-select" />
    </div>
    <div class="promocodes-field-wrap">
      <span class="promocodes-label nowrap"> {{ discount.type === 0 ? localizeList.enterPromocode : localizeList.enterDiscountCard }} </span>
      <input v-model="discount.value"
             @input="(event) => discount.value = maskInputForNumber(event, discount.type)"
             class="promocodes-input"/>
    </div>
    <div class="promocodes-field-wrap btn">
      <base-button @click="applyPromocode"
                   size="14"
                   padding="5px 10px"
                   background="var(--lighten-6-color)"
                   color="var(--dark-1-color)">
        {{ localizeList.applyUpper }}
      </base-button>
    </div>

    <div class="promocodes-errors-wrap" v-show="isError"> 
      <p class="promocodes-error nowrap" v-if="discount.type === 0"> {{ localizeList.promocodeNotFound }}</p>
      <p class="promocodes-error nowrap" v-else> {{ localizeList.discountCardNumberIncorrect }} </p>
    </div>
  </div>
</template>

<script>
import * as typesBasket from '@/stores/modules/basket/types'
import moment from "moment";


export default {
  name: "PromocodesBlock",

  props: {
    tour: {
      type: Object,
      default: () => ({}),
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    }
  },

  data() {
    return {
      discountTypes: [],
      discount: {
        type: 0,
        value: "",
      },
      isError: false,
      isMounted: false
    };
  },

  async mounted() {
    const baseType = { label: this.localizeList.promocode, value: 0 };
    this.discountTypes.push(baseType)

    await this.getPromocodes();
    this.isMounted = true
  },

  methods: {
    async applyPromocode() {
      if (!this.discount.value) return

      if (this.discount.type === 0) {
        const payload = {
          promocode: this.discount.value,
          TPKey: this.tour.Key,
          countryKey: this.tour.CountryId,
        }

        const value = await this.$store.dispatch("basket/" + typesBasket.A_CHECK_PROMOCODE, payload);
        if (value) {
          this.$emit("applyPromoOrDiscount", {type: 0, value});
          this.isError = false
        } else {
          this.$emit("applyPromoOrDiscount", {type: "clear"});
          this.isError = true
        }
      } else {
        const payload = {
          key: this.discount.type,
          symbolsNumber: this.discount.value.length ? this.discount.value.length : 0,
          dateIn: moment(this.tour.StartDate).format("DD.MM.YYYY")
        }

        const value = await this.$store.dispatch("basket/" + typesBasket.A_CHECK_DISCOUNT, payload);
        if (value) {
          this.$emit("applyPromoOrDiscount", {type: 1, value});
          this.isError = false
        } else {
          this.$emit("applyPromoOrDiscount", {type: "clear"});
          this.isError = true
        }
      }
    },
    async getPromocodes() {
      const payload = {
        dateIn: moment(this.tour.StartDate).format("DD.MM.YYYY")
      }

      const data = await this.$store.dispatch("basket/" + typesBasket.A_GET_PROMOCODES, payload);
      if (!data) return;

      const dataTypes = data.map((el) => {
        const { Name, Key } = el;
        return { label: Name, value: Key };
      }).sort((a, b) => a.label.localeCompare(b.label));

      this.discountTypes = [...this.discountTypes, ...dataTypes];
    },
    maskInputForNumber(event, type = 0) {
      if (type === 0) {
        return event.target.value
      } else {
        return event.target.value.replace(/[^0-9]/g, "");
      }
    },
    reset() {
      this.discountTypes = [
        { label: this.localizeList.promocode, value: 0 },
      ];
      this.discount = {
        type: 0,
        value: "",
      };
      this.isError = false
    },
  },

  computed: {
  },

  watch: {
    "userInfo.UserType": {
      handler() {
        if (!this.isMounted) return
        this.reset();
        this.getPromocodes();
        this.$emit("applyPromoOrDiscount", {type: "clear"});
      }
    },
    "discount.type": {
      handler() {
        const discountType = this.discountTypes.find((el) => el.value === this.discount.type);
        this.$emit("discountTypeData", discountType);
        this.discount.value = "";
        this.isError = false
      }
    },
  },

  components: {
  },
};
</script>

<style>
  .promocodes-block {
    display: flex;
    flex-direction: column;
    row-gap: 15px;
    padding: 15px 16px;
  }

  .promocodes-block .promocodes-field-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    font-size: 14px;
    line-height: 16px;
    color: var(--dark-1-color);
  }

  .promocodes-block .promocodes-field-wrap.btn {
    justify-content: flex-end;
    font-weight: 500;
  }

  .promocodes-block .promocodes-field-wrap .base-button {
    border: 1px solid #E0E0E0;

  }

  .promocodes-block .promocodes-field-wrap .promocodes-input {
    width: 100%;
    box-sizing: border-box;
    border: none;
    outline: none;
    padding: 12px 58px 12px 12px;
    background-color: var(--lighten-6-color);
    border-radius: 3px;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #333;
    cursor: pointer;
  }

  .promocodes-block .promocodes-field-wrap .promocodes-select,
  .promocodes-block .promocodes-field-wrap .promocodes-input {
    width: 160px;
  }

  .promocodes-block .promocodes-field-wrap .promocodes-input {
    padding: 2.5px 5px;
    background-color: var(--white-color);
    border: 1px solid #E0E0E0;
    font-size: 14px;
    line-height: 16px;
    color: var(--dark-1-color);
  }

  .promocodes-block .promocodes-field-wrap .promocodes-select .select {
    padding: 2.5px 20px 2.5px 5px;
    background-color: var(--white-color);
    border: 1px solid #E0E0E0;
    font-size: 14px;
    line-height: 16px;
    color: var(--dark-1-color);
  }

  .promocodes-block .promocodes-field-wrap .promocodes-input:focus {
    border: 1px solid var(--primary-color);
    padding: 2.5px 5px;
  }

  .promocodes-block .promocodes-errors-wrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 14px;
    line-height: 14px;
    color: var(--red-color);
  }
</style>
